/* unplugin-vue-components disabled */import { render } from "./Jijing.vue?vue&type=template&id=6597ad5b&scoped=true"
const script = {}

import "./Jijing.vue?vue&type=style&index=0&id=6597ad5b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6597ad5b"]])

export default __exports__